export default __webpack_public_path__ + "static/media/down-arrow.e5284d57.svg";